import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DropzoneComponent from 'react-dropzone-component';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import PhotosList from '../PhotosList';

import dropzoneErrors from '../../helpers/dropzoneErrors';
import messages from '../../locale/messages';
import showToaster from '../../helpers/showToaster';
import { createListPhotos, removeListPhotos } from '../../actions/manageListPhotos';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';

import withStyles from 'isomorphic-style-loader/withStyles';

import PictureImage from '/public/SiteIcons/photoUpload.svg';

import s from 'react-dropzone-component/styles/filepicker.css';
import t from 'dropzone/dist/min/dropzone.min.css';
import cs from '../../styles/documentUploadDropzone.css';
class PhotosUpload extends Component {

  static propTypes = {
    createListPhotos: PropTypes.any.isRequired,
    removeListPhotos: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.dropzone = null;
    this.state = {
      djsConfig: {}
    }
  }

  async componentDidMount() {
    const { placeholder, maxUploadSize } = this.props;
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== undefined;

    if (isBrowser && isDocument) {
      document.querySelector(".dz-hidden-input").style.visibility = 'visible';
      document.querySelector(".dz-hidden-input").style.opacity = '0';
      document.querySelector(".dz-hidden-input").style.height = '100%';
      document.querySelector(".dz-hidden-input").style.width = '100%';
      document.querySelector(".dz-hidden-input").style.cursor = 'pointer';
    }

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: placeholder,
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          maxFiles: 20,
          acceptedFiles: 'image/jpeg,image/png',
          hiddenInputContainer: '.dzInputContainer',
        }
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { placeholder, maxUploadSize } = this.props;

    if (placeholder) {
      this.setState({
        djsConfig: {
          dictDefaultMessage: placeholder,
          addRemoveLinks: false,
          maxFilesize: maxUploadSize,
          maxFiles: 20,
          acceptedFiles: 'image/jpeg,image/png',
          hiddenInputContainer: '.dzInputContainer',
        }
      });
    }
  }

  error = async (file) => {
    const { maxUploadSize } = this.props;
    dropzoneErrors(file, maxUploadSize);
    this.dropzone.removeFile(file);
  };

  complete = async (file) => {
    const { listId, createListPhotos, userRestriction } = this.props;

    const isRestrict = await userRestriction({ restrictType: 'listing', restrictValue: listId });
    if (isRestrict) {
      showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
      return;
    }

    let isOnline = typeof window !== 'undefined' && window.navigator.onLine;

    if (!isOnline) {
      showToaster({ messageId: 'offlineError', toasterType: 'error' })
      this.dropzone.removeFile(file);
      return;
    }
    if (file && file.xhr) {
      const { files } = JSON.parse(file.xhr.response);
      let fileName = files[0].filename;
      let fileType = files[0].mimetype;
      if (listId != undefined) {
        createListPhotos(listId, fileName, fileType);
      }
      this.dropzone.removeFile(file);
    }
  }

  render() {
    const { listId, maxUploadSize } = this.props;
    const { djsConfig } = this.state;

    const componentConfig = {
      iconFiletypes: ['.jpg', '.png'],
      postUrl: '/photos'
    };
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      complete: this.complete,
      error: this.error,
    };

    return (
      <div className={cx('documentUploadDropzoneContainer', 'becomeHostDropzoneContainer')}>
        <div className={cx('dzInputContainer', 'svgImg')}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            <img src={PictureImage} className={cx('documentUploadDropzoneIcon')} alt='PictureImage' />
          </DropzoneComponent>
        </div>
        <div className={'becomeHostDropzoneUploadText'}>
          <FormattedMessage {...messages.uploadSizedLabel} /> {maxUploadSize}MB
        </div>
        <PhotosList listId={listId} />
      </div>
    );
  }
}

const mapState = (state) => ({
  maxUploadSize: state?.siteSettings?.data?.maxUploadSize
});

const mapDispatch = {
  createListPhotos,
  removeListPhotos,
  userRestriction
};

export default injectIntl(withStyles(s, t, cs)(connect(mapState, mapDispatch)(PhotosUpload)));